module.exports = __webpack_public_path__ + "img/chat.43e9ec87.svg";